import { render, staticRenderFns } from "./WikipediaTile.vue?vue&type=template&id=3c6d5bb8&"
import script from "./WikipediaTile.vue?vue&type=script&lang=js&"
export * from "./WikipediaTile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "WikipediaTile.vue"
export default component.exports